import React from 'react';
import {HeaderHeight} from 'theme/settings';
import {ActivityIndicator} from '../activityIndicator';
import {Layout} from '../layout';
import {Text} from '../text';
import {useLoadingText} from './hooks';

type Props = {
  loadingType?: string;
  applySceneHeight?: boolean;
};
export const SceneLoader: React.FC<Props> = ({
  loadingType,
  applySceneHeight,
}) => {
  const loadingText = useLoadingText(loadingType);

  return (
    <Layout
      className={'asdasd'}
      adjustCenter
      paddingTop="20vh"
      mt={applySceneHeight ? `${HeaderHeight}px` : 0}>
      <ActivityIndicator />
      <Text kind="primary" variant="h4" sx={{mt: 2}}>
        {loadingText}
      </Text>
    </Layout>
  );
};
